import { List, ListItem, ListItemText } from '@mui/material';
import { NavLink } from 'react-router-dom';
// Replace @material-ui/core with @mui/styles
import { makeStyles } from '@mui/styles';
import Grid from "@mui/material/Grid";
import "./sidebar.scss";

const useStyles = makeStyles({
  root: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    fontFamily: "sans-serif",
  },
});

const SideBar = () => {
  const classes = useStyles();
  return (
    <Grid container spacing={4}>
      <List style={{minHeight: '100vh'}} sx={{padding: 0 ,marginTop:{xs: '85px', md: '0px'}}}>
        <ListItem
          className='ListItem'
          component={NavLink}
          to="/about/terms"
          sx={{ 
            "&.active": {
              color: "#213554",
              fontWeight: 600,
              fontSize: "21px"
            }
          }}
        >
          <ListItemText classes={{ primary: classes.root }} primary="Terms and Conditions" />
        </ListItem>
        <ListItem
          className='ListItem'
          component={NavLink}
          to="/about/privacy"
          sx={{ 
            "&.active": {
              color: "#213554",
              fontWeight: 600,
              fontSize: "21px"
            }
          }}
        >
          <ListItemText classes={{ primary: classes.root }} primary="Privacy Policy" />
        </ListItem>
        <ListItem
          className='ListItem'
          component={NavLink}
          to="/about/pricing"
          sx={{ 
            "&.active": {
              color: "#213554",
              fontWeight: 600,
              fontSize: "21px"
            }
          }}
        >
          <ListItemText classes={{ primary: classes.root }} primary="Products and Pricing" />
        </ListItem>
        <ListItem
          className='ListItem'
          component={NavLink}
          to="/about/contact"
          sx={{ 
            "&.active": {
              color: "#213554",
              fontWeight: 600,
              fontSize: "21px"
            }
          }}
        >
          <ListItemText classes={{ primary: classes.root }} primary="Contact Us" />
        </ListItem>
      </List>
    </Grid>
  );
};

export default SideBar;
